import type { TabularDataCell } from "../../../../../../api/types/svTypes";

export const PERIOD_GUID = "AgingPeriod";
export const FIRST_COLUMN_GUID = "PostingDate";

export interface AgingDetailGridRow {
  id: string;
  data: Record<string, TabularDataCell>;
  [PERIOD_GUID]?: string;
}
